module.exports = __webpack_public_path__ + "static/img/catarina.e34fea5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/catarina.svg
// module id = aRfh
// module chunks = 1